/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import {
  useGetCashCenters,
  useGetRegions,
  useGetOffices,
  useEditRoute,
  useGetRouteDetails
} from "../../services/routes-api";
import {
  Button,
  Combobox,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Input
} from "@repo/ui";
import { formatDate } from "date-fns";

const currentDate = new Date();

const jobPriorities = [
  {
    value: "1",
    label: "High"
  },
  {
    value: "2",
    label: "Normal"
  },
  {
    value: "3",
    label: "Low"
  }
];

const routeStatusList = [
  {
    id: "Active",
    text: "Active"
  },
  {
    id: "Closed",
    text: "In Active"
  }
];

const routeType = [
  { label: "Morning Route", value: "Morning Route" },
  { label: "Dedicated Route", value: "Dedicated Route" },
  { label: "Night TVM Route", value: "Night TVM Route" },
  { label: "VIT Team", value: "VIT Team" },
  { label: "Foot Team", value: "Foot Team" },
  { label: "Bike Rider", value: "Bike Rider" },
  { label: "FLM Route", value: "FLM Route" },
  { label: "Mobile ATM Team", value: "Mobile ATM Team" },
  { label: "Internal Route", value: "FLM Route Route" }
];

function EditRoute({ route, onRouteUpdated }) {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [btnSaveText, setBtnSaveText] = useState("Update Route");
  const [routeData, setRouteData] = useState({});

  const { data: routeDetails } = useGetRouteDetails(route?.routeId);
  useEffect(() => {
    if (routeDetails) {
      const _routeDetails = routeDetails.data;
      const _route = {
        routeId: _routeDetails.routeId,
        cashCenter: _routeDetails.cashCenterId,
        routeType: _routeDetails.routeType,
        office: _routeDetails.officeId,
        routeNo: _routeDetails.routeNo,
        description: _routeDetails.description,
        region: _routeDetails.region,
        routeArea: _routeDetails.routeArea,
        priority: _routeDetails?.priority?.toString(),
        requiredTeamMembers: _routeDetails.requiredTeamMembers,
        teamNationalityCount: _routeDetails.teamNationalityCount,
        routeStartTime: route.routeStartTime
          ? new Date(route.routeStartTime)
          : currentDate,
        routeEndTime: route.routeEndTime
          ? new Date(route.routeEndTime)
          : currentDate,
        status: _routeDetails.status
      };
      setRouteData(_route);
    }
  }, [routeDetails]);
  const [error, setError] = useState({
    cashCenter: "",
    office: "",
    routeNo: "",
    routeType: "",
    description: "",
    region: "",
    routeArea: "",
    priority: "",
    requiredTeamMembers: 0,
    teamNationalityCount: 0,
    routeStartTime: null,
    routeEndTime: null,
    status: ""
  });

  const { data: cashCenters } = useGetCashCenters();
  const { data: cities } = useGetRegions("UAE");
  const { mutate: getOffices, data: offices } = useGetOffices();
  const {
    mutate: editRoute,
    isSuccess: editSuccess,
    isError: editError
  } = useEditRoute();

  useEffect(() => {
    if (route.cashCenterId) {
      getOffices(route.cashCenterId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.cashCenterId]);

  const onCashCentersChanged = (value) => {
    setRouteData({ ...routeData, cashCenter: value });

    if (!value) return;
    getOffices(value);
  };

  const onBtnUpdateRouteClicked = () => {
    let errorCount = 0;

    const errorObj = {
      cashCenter: "",
      routeNo: "",
      description: "",
      region: "",
      routeArea: "",
      priority: "",
      office: "",
      requiredTeamMembers: 0,
      teamNationalityCount: 0,
      routeStartTime: null,
      routeEndTime: null,
      status: ""
    };

    if (!routeData.cashCenter) {
      errorCount++;
      errorObj.cashCenter = "red-500";
    }

    if (!routeData.office) {
      errorCount++;
      errorObj.office = "red-500";
    }

    if (!routeData.routeType) {
      errorCount++;
      errorObj.routeType = "red-500";
    }

    if (routeData.routeNo === "") {
      errorCount++;
      errorObj.routeNo = "red-500";
    }

    if (routeData.description === "") {
      errorCount++;
      errorObj.description = "red-500";
    }

    if (!routeData.region) {
      errorCount++;
      errorObj.region = "red-500";
    }

    if (routeData.priority === "") {
      errorCount++;
      errorObj.priority = "red-500";
    }

    if (
      routeData.requiredTeamMembers === 0 ||
      routeData.requiredTeamMembers > 5
    ) {
      errorCount++;
      errorObj.requiredTeamMembers = "red-500";
    }

    if (
      routeData.teamNationalityCount === 0 ||
      routeData.requiredTeamMembers > 5
    ) {
      errorCount++;
      errorObj.teamNationalityCount = "red-500";
    }

    if (!routeData.routeArea) {
      errorCount++;
      errorObj.routeArea = "red-500";
    }
    if (routeData.routeStartTime === null) {
      errorCount++;
      errorObj.routeStartTime = "red-500";
    }

    if (routeData.routeEndTime === null) {
      errorCount++;
      errorObj.routeEndTime = "red-500";
    }

    if (!routeData.status) {
      errorCount++;
      errorObj.status = "red-500";
    }

    if (errorCount) {
      setError(errorObj);
      return;
    }
    setError(errorObj);
    const _routeDetails = routeDetails.data;
    const obj = {
      routeId: routeData.routeId,
      cashCenterId: routeData.cashCenter,
      officeId: routeData.office,
      routeNo: routeData.routeNo,
      routeType: routeData.routeType,
      routeArea: routeData.routeArea,
      description: routeData.description,
      region: routeData.region,
      priority: parseInt(routeData.priority),
      requiredTeamMembers: routeData.requiredTeamMembers,
      teamNationalityCount: routeData.teamNationalityCount,
      routeStartTime: formatDate(
        routeData.routeStartTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      routeEndTime: formatDate(
        routeData.routeEndTime,
        "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      ),
      status: routeData.status || _routeDetails.status,
      busTime: _routeDetails.busTime,
      routeTime: _routeDetails.routeTime,
      vanRegistrationNo: _routeDetails.vanRegistrationNo,
      cashBoxSerial: _routeDetails.cashBoxSerial,
      hhtSerial: _routeDetails.hhtSerial,
      printerSerial: _routeDetails.printerSerial,
      requestedBy: _routeDetails.requestedBy,
      comments: _routeDetails.comments
    };

    setBtnDisabled(true);
    setBtnSaveText("Updating Route....");
    editRoute(obj);
  };

  useEffect(() => {
    if (editSuccess) {
      setBtnDisabled(false);
      setBtnSaveText("Update Route");
      setRouteData({
        routeId: route.routeId,
        cashCenter: route.cashCenter,
        office: route.office,
        routeType: route.routeType,
        routeNo: route.routeNo,
        description: route.description,
        region: route.region,
        routeArea: route.routeArea,
        priority: route.priority,
        requiredTeamMembers: route.requiredTeamMembers,
        teamNationalityCount: route.teamNationalityCount,
        routeStartTime: route.routeStartTime
          ? new Date(route.routeStartTime)
          : currentDate,
        routeEndTime: route.routeEndTime
          ? new Date(route.routeEndTime)
          : currentDate,
        status: { id: route.status, text: route.status }
      });
      onRouteUpdated();
    }

    if (editError) {
      setBtnDisabled(false);
      setBtnSaveText("Update Route");
      onRouteUpdated();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editSuccess, editError]);

  return (
    <>
      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-[${error.cashCenter}]`}>
            Cash Center<sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cashCenters?.data?.map((m) => ({
              value: m.cashCenterId,
              label: m.name
            }))}
            value={routeData.cashCenter}
            setValue={onCashCentersChanged}
            placeholder="Select Cash center"
          />
        </div>

        <div className="flex-1">
          <label>Office</label>
          <Combobox
            data={offices?.data?.map((m) => ({
              value: m.officeId,
              label: m.officeName
            }))}
            placeholder="Select Office"
            value={routeData.office}
            setValue={(e) => {
              setRouteData({ ...routeData, office: e });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-sm text-${error.routeType}`}>
            Route Type <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={routeType}
            placeholder="Select Route Type"
            value={routeData.routeType}
            setValue={(e) => {
              setRouteData({ ...routeData, routeType: e });
            }}
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-${error.routeNo}`}>
            Route No
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route No"
            value={routeData.routeNo}
            onChange={(e) => {
              setRouteData({ ...routeData, routeNo: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-${error.description}`}>
            Description
            <sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route Description"
            value={routeData.description}
            onChange={(e) => {
              setRouteData({ ...routeData, description: e.target.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-${error.region}`}>
            Region
            <sup className="text-red-500">*</sup>
          </label>
          <Combobox
            data={cities?.data?.map((m) => ({
              label: m.name,
              value: m.name
            }))}
            value={routeData.region}
            setValue={(e) => {
              setRouteData({ ...routeData, region: e });
            }}
            placeholder="Select Route Area"
          />
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-sm text-${error.routeArea}`}>
            Area<sup className="text-red-500">*</sup>
          </label>
          <Input
            placeholder="Route Area"
            value={routeData.routeArea}
            onChange={(e) =>
              setRouteData({ ...routeData, routeArea: e.target.value })
            }
          />
        </div>
        <div className="flex-1">
          <label className={`text-${error.priority}`}>
            Priority
            <sup className="text-red-500">*</sup>
          </label>
          <Select
            onValueChange={(e) => {
              setRouteData({ ...routeData, priority: e });
            }}
            value={routeData.priority}
          >
            <SelectTrigger>
              <SelectValue placeholder="Route Priority" />
            </SelectTrigger>
            <SelectContent>
              {jobPriorities?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex-1">
          <label className={`text-${error.requiredTeamMembers}`}>
            Required Team Members
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={1}
            max={5}
            className="h-10"
            placeholder="Required Team Members Count"
            value={routeData.requiredTeamMembers}
            onChange={(e) => {
              setRouteData({
                ...routeData,
                requiredTeamMembers: e.target.value
              });
            }}
          />
          {error.requiredTeamMembers ? (
            <i className="text-sm text-red-500">
              Min 1 or Max 5 team members allowed.
            </i>
          ) : null}
        </div>
      </div>

      <div className="flex gap-4 mb-3">
        <div className="flex-1">
          <label className={`text-${error.teamNationalityCount}`}>
            Co-National Count
            <sup className="text-red-500">*</sup>
          </label>
          <NumericTextBox
            min={1}
            max={5}
            className="h-10"
            placeholder="Max. Same Nationals Count"
            value={routeData.teamNationalityCount}
            onChange={(e) => {
              setRouteData({
                ...routeData,
                teamNationalityCount: e.target.value
              });
            }}
          />
          {error.teamNationalityCount ? (
            <i className="text-sm text-red-500">
              Min 1 or Max 5 nationality allowed.
            </i>
          ) : null}
        </div>
        <div className="flex-1">
          <label className={`text-${error.routeStartTime}`}>
            Route Start Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            placeholder="Route Start Time"
            className="h-10"
            value={routeData.routeStartTime}
            onChange={(e) => {
              setRouteData({ ...routeData, routeStartTime: e.value });
            }}
          />
        </div>

        <div className="flex-1">
          <label className={`text-${error.routeEndTime}`}>
            Route End Time
            <sup className="text-red-500">*</sup>
          </label>
          <TimePicker
            className="h-10"
            placeholder="Route Start Time"
            value={routeData.routeEndTime}
            onChange={(e) => {
              setRouteData({ ...routeData, routeEndTime: e.value });
            }}
          />
        </div>
      </div>
      <div className="flex gap-4">
        <div className="flex-1">
          <label className={`text-${error.status}`}>
            Route Status
            <sup className="text-red-500">*</sup>
          </label>
          <Select
            onValueChange={(e) => {
              setRouteData({ ...routeData, status: e });
            }}
            value={routeData.status}
          >
            <SelectTrigger>
              <SelectValue placeholder="Route Priority" />
            </SelectTrigger>
            <SelectContent>
              {routeStatusList.map((item) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="flex-1" />
        <div className="flex-1" />
      </div>
      <div className="border-b my-3 bg-accent" />
      <Button
        variant="secondary"
        onClick={onBtnUpdateRouteClicked}
        disabled={btnDisabled}
        className="ml-auto flex w-[140px]"
      >
        {btnSaveText}
      </Button>
    </>
  );
}

export default EditRoute;
